const variantRadioComponent = document.querySelector('variant-radios');

/* 
  ** Sempre que uma variação de material é selecionada um evento é 
  ** disparado a partir de variants.js com o valor do material.
*/

// Adiciona um ouvinte para o evento 'materialChange'
variantRadioComponent.addEventListener('materialChange', function(event) {
  const materialValue = event.detail.material;
  changeAllUpsellMaterials(materialValue);
});

function changeAllUpsellMaterials(meterial) {
  const materialCode = meterial.match(/\d+/)?.[0]; // Obtém apenas o número (ex: "430")

  if (!materialCode) return; // Se não encontrar um número, interrompe a função

  const upsellProducts = document.querySelectorAll('.upsell-product');

  upsellProducts.forEach(upsell => {
    const selectElement = upsell.querySelector('select');

    if (selectElement) {
      Array.from(selectElement.options).forEach(option => {
        if (option.text.includes(materialCode)) {
          selectElement.value = option.value;
        }
      });
    }
  });
}